import { render, staticRenderFns } from "./viztype-screen.vue?vue&type=template&id=6c8f9a50"
import script from "./viztype-screen.vue?vue&type=script&lang=js"
export * from "./viztype-screen.vue?vue&type=script&lang=js"
import style0 from "./viztype-screen.vue?vue&type=style&index=0&id=6c8f9a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports